import {Sequence} from "./sequence";

/** Returns the set difference of a - b */
export function setDiff<T>(a: Set<T>, b: Set<T>): Set<T> {
    return Sequence.from(a).filter(x => !b.has(x)).collectToSet();
}
